import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Button, Grid, Stack, TextField, Typography,
} from '@mui/material';
import { saveSiteConfiguration } from '../../../../features/Configuration/configurationAction';
import { InfoChip } from '../../../../components/CustomChip';
import useToggle from '../../../../hooks/useToggle';
import { openSnackbar } from '../../../../features/SnackBar/snackBarSlice';
import useStyles from '../../../../hooks/useStyles';
import styles from '../../../../layouts/pages/style';

function CustomOrgNameCard() {
  const dispatch = useDispatch();
  const customOrgName = useSelector((state) => state.siteConfiguration?.data?.customAccountName);

  const [orgName, setOrgName] = useState('');
  const [enableSave, setEnableSave] = useToggle();

  useEffect(() => {
    if (customOrgName) {
      setOrgName(customOrgName);
    }
  }, [customOrgName]);

  const handleSubmit = () => {
    dispatch(saveSiteConfiguration({ customAccountName: orgName }))
      .then((res) => {
        if (res.error) {
          dispatch(openSnackbar({ open: true, message: res.payload, type: 'error' }));
        } else {
          setEnableSave(false);
          dispatch(openSnackbar({ open: true, message: 'Successfully Updated!', type: 'success' }));
        }
      });
  };

  const handleNameChange = (e) => {
    setOrgName(e.target.value);
    setEnableSave(true);
  };

  const classes = useStyles(styles)();

  return (
    <Box className={classes.cardStyles} sx={{ width: '100%' }}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography sx={{ fontSize: '22px', fontWeight: 500 }}>
          Organization Name Mapping
        </Typography>
        {enableSave && <Button size="small" variant="outlined" onClick={handleSubmit}>Save</Button>}
      </Stack>

      {/* Content */}
      <Grid container gap={2}>
        <InfoChip icon label="You can set custom mapping for Organization Name" />

        <Grid item container display="flex" justifyContent="space-between" alignItems="flex-end">
          <Grid item xs={8}>
            <Typography>Custom Org Name in License Object</Typography>
            <Typography fontSize="small">Enter the field in your license object which you are using for storing Orgnization names.</Typography>
          </Grid>

          <Grid item xs={3}>
            <TextField
              label="Name"
              fullWidth
              value={orgName}
              onChange={handleNameChange}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CustomOrgNameCard;
